import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-hrclosure-grid',
  templateUrl: './hrclosure-grid.component.html',
  styleUrls: ['./hrclosure-grid.component.scss']
})
export class HRclosureGridComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }
editEmployee(data){
  this.appservice.hrclosureeditid=data;
  //console.log("the edit id",this.appservice.hrclosureeditid);
  this.router.navigate(['/home/hrclosure'])
}
GetOnboardingGrid(){
  this.appservice.Hrcloser_type="Onboarding";
  this.appservice.gethrclosuredata();
}
GetOffboardingGrid(){
  this.appservice.Hrcloser_type="Offboarding";
  this.appservice.GetOffboardingDetails();
}
GetRolechangeGrid(){
  this.appservice.Hrcloser_type="Role Change";
  this.appservice.GetRolechangeDetails();
}
  ngOnInit(): void {
    this.appservice.gethrclosuredata();
  }

}
